export default function mobileNav() {
  /*****************  Navigation du site pour les mobiles *****************/

  var navTrigger = document.querySelector('.nav-trigger');
  var body = document.querySelector('body');
  var mainNav = document.querySelector('.main-navigation');
  var navItemsArr = Array.from(document.querySelectorAll('.main-navigation li a '));

  navTrigger.addEventListener('click', function (e) {
    e.preventDefault();
    body.classList.toggle('nav-open');
    mainNav.classList.toggle('menu-open');
  });


  navItemsArr.forEach(function (navItem) {
    navItem.addEventListener('click', function () {
      if (body.classList.contains('nav-open')) {
        body.classList.toggle('nav-open');
        mainNav.classList.toggle('menu-open');
      }
    })
  });
}
